import { FC } from "react";
import Button from "Components/Button";
import { CroppedImage, Wrapper } from "./ImagePreview.styled";

type Props = {
  cropData: any;
  setCropData: any;
};

const ImagePreview: FC<Props> = ({ cropData, setCropData }) => {
  if (cropData === "#") {
    return null;
  }
  return (
    <Wrapper>
      <CroppedImage src={URL.createObjectURL(cropData)} alt="cropped" />
      <Button handleClick={() => setCropData("#")} buttonStyles="secondary" className="ghost-btn">
        Cancel
      </Button>
    </Wrapper>
  );
};

export default ImagePreview;
